import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react'

export function HeroCTA() {
  return (
    <div>
      <div className="flex flex-col md:flex-row justify-center gap-4">



        <a href="#waitlist" className="bg-navy text-white px-8 py-4 rounded-lg text-lg font-bold shadow-lg hover:translate-y-[-2px] transition">Join The Waitlist</a>




        <a href="#" className="bg-white border-2 border-slate-200 text-slate-700 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-50 transition">View the Demo</a>
      </div>
      <p className="mt-6 text-sm text-slate-400 font-medium">No credit card required for the Free Tier (25 expenses/yr).</p>
    </div>
  );
}
